import React from "react";

const ReportStatCard = ({
  title,
  value,
  subtitle,
}) => {
  return (
    <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
      <div className="card border-0 shadow-sm h-100">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-start">
            <div>
              <p className="text-muted mb-2 small">{title}</p>

              <h4 className={`fw-bold mb-1`}>{value}</h4>

              {subtitle && <small className="text-muted">{subtitle}</small>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportStatCard;
